import React from "react";
import AppContext from "../../contexts/AppContext";
import SectionView from "./SectionView";
import {mapSelectedImageItem, webviewAnalyticsEvent, webviewCall} from "../../utils/webview";
import clientStorage from "../../utils/client-storage";
import {goToProcessing} from "../../utils/url";
import {IndexPageStyled} from "./IndexPage.style";
import processingManager from "../../photolab/ProcessingManager";
import {debounce} from "../../utils/etc";
import {logEvent} from "../../utils/log";
import Loader from "../../components/Loader/Loader";
import {signalEvent, signals} from "../../utils/signals";
import RulesModal from "../shared/RulesModal";
import PreviewWebBlock from "./PreviewWebBlock";
import webApiHelper from "../../helpers/web-api.helper";

export default class IndexPage extends React.Component {

  state = {
    isLoading: true,
  };

  blocksRefsMap = new WeakMap();
  intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const entryData = this.blocksRefsMap.get(entry.target);
        // if (entryData) {
        //   analyticsHelper.templateView(entryData.data.name, entryData.gender);
        // }
      }
    });
  }, {
    root: null,
    threshold: 0.5,
  });

  componentDidMount() {
    const isFirstVisit = this.props.match.params.user_id
      && (!clientStorage.getUserId() || clientStorage.getUserId() !== this.props.match.params.user_id);

    if (this.props.match.params.user_id) {
      clientStorage.setUserId(this.props.match.params.user_id);
      window.clientConfig.userId = this.props.match.params.user_id;

      if (isFirstVisit) {
        webApiHelper.fetchImage()
          .then((response) => {
            if (response.image_url) {
              this.startWithFiles([{url: response.image_url}]);
            } else {
              this.setState({isLoading: false});
            }
          })
          .catch((e) => {
            console.error(e);
            this.setState({isLoading: false});
          });

        return;
      }
    }

    this.setState({isLoading: false});

    // if (!isWebviewApp(webviewAppIds.hotify)) {
    //   this.props.history.replace(routes.PROMO);
    //   return;
    // }

    const loadedUrl = new URL(window.location.href);
    const reason = loadedUrl.searchParams.get("reason");
    if (reason != null) {
      logEvent("index_open_reason", {reason});
    }

    window.webviewEventsListeners.photoSelected.setListener(this.handleWebviewFilesSelected);
  }

  componentWillUnmount() {
    window.webviewEventsListeners.photoSelected.removeListener();
  }

  startWithFiles = (files) => {
    const section = this.context.config.sections.find((s) => s.name === "undressing");
    const block = section.blocks.find((s) => s.name === "undressing_common");

    clientStorage.incrementSelectedBlocksAmount();

    clientStorage.setLatestBlock({
      config: {
        id: this.context.config.id,
        version: this.context.config.version,
      },
      section: section.name,
      section_position: this.context.config.sections.findIndex((s) => s.name === section.name),
      block: block.name,
      block_position: section.blocks.findIndex((b) => b.name === block.name),
      people: 1,
      isPro: block.extra.is_pro
    });

    this.handleFilesSelected(files);
  }

  startChoosePhoto = (faceCount, block) => {
    let params = {
      func: "onNativeAppPhotoSelected",
      use_crop: 1,
      num_photos: 1,
      show: "gallery",
      tab: "faces",
      face_count: faceCount || 1,
      face_percent_gte: 2,
    }

    if (block.includes("ipadapter")) {
      params = {
        ...params,
        use_crop: 0,
        neurocamera: 1,
        face_count: 1,
      }
    } else {
      params = {
        ...params,
        asp: 0.75,
        hi_res: 1,
        face_b_gte: faceCount === 2 ? 1 : 2,
      }
    }
    
    if (window.clientConfig.isWebview) {
      webviewCall("nativePhotoSelect", params);
    } else {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.addEventListener("change", (e) => {
        this.handleBrowserFilesSelected(e.target.files);
      });
      input.click();
    }
  }

  handleBrowserFilesSelected = (files) => {
    this.handleFilesSelected(files);
  };

  handleWebviewFilesSelected = (data) => {
    if (!data || !data.photos || data.photos.length === 0) {
      return;
    }

    const files = data.photos.map((item) => mapSelectedImageItem(item));

    this.handleFilesSelected(files);
  };

  handleFilesSelected = (files) => {
    if (clientStorage.getLatestBlock() === null) {
      return;
    }

    if (!clientStorage.getLatestBlock().isPro || (clientStorage.getLatestBlock().isPro && window.clientConfig.isPro)) {
      signalEvent(signals.photoSelected);
    }

    clientStorage.setLatestSelectedImages(files);
    processingManager.clear();

    webviewAnalyticsEvent("photo_selected", [
      clientStorage.getSelectedPhotosAmount(),
    ], {
      wt_hotify: {
        block_cnt: clientStorage.getSelectedBlocksAmount(),
      }
    });

    if (window.clientConfig.isWebview && window.clientConfig.appTabs.indexOf("7940h") > -1) {
      this.setState({isLoading: true});
      setTimeout(() => {
        this.setState({isLoading: false});
        window.location.href = "hotify://navigate/tab?id=7940";
      }, 2000);
    } else {
      goToProcessing(this.props.history, files);
    }
  };

  handleBlockClick = async (section, block) => {
    if (!clientStorage.rulesAccepted()) {
      await new Promise((resolve) => {
        this.context.pushModal(<RulesModal
          key="RulesModal"
          className="rules-modal"
          onContinue={() => {
            clientStorage.acceptRules();

            resolve();
          }}
        />);
      });
    }

    console.log("section", section.name);
    console.log("block", block.name);
    console.log("block extra", block.extra);

    const allCreatives = [
      ...block.creatives,
      ...section.blocks.flatMap((block) => block.creatives),
    ];
    const peopleAmount = allCreatives.first().people || 1;

    clientStorage.incrementSelectedBlocksAmount();

    webviewAnalyticsEvent("block_selected", [
      clientStorage.getSelectedBlocksAmount(),
      section.name,
      block.name,
    ]);

    clientStorage.setLatestBlock({
      config: {
        id: this.context.config.id,
        version: this.context.config.version,
      },
      section: section.name,
      section_position: this.context.config.sections.findIndex((s) => s.name === section.name),
      block: block.name,
      block_position: section.blocks.findIndex((b) => b.name === block.name),
      people: peopleAmount,
      isPro: block.extra.is_pro
    });

    debounce("IndexPage_startChoosePhoto", 240, () => {
      this.startChoosePhoto(peopleAmount, section.name);
    });
  };

  handleBlockRef = (ref, data, gender) => {
    if (!ref) {
      return;
    }

    this.blocksRefsMap.set(ref, {data, gender});
    this.intersectionObserver.observe(ref);
  };

  render() {
    if (this.state.isLoading) {
      return <Loader />;
    }

    const sortingSections = [
      "ipadapter",
      "undressing",
      "hot_look",
      "perfect_body",
      "couples",
    ];

    const configSections = this.context.config.sections
      .sort((a, b) => sortingSections.indexOf(a.name) - sortingSections.indexOf(b.name));

    return (
      <IndexPageStyled>
        <PreviewWebBlock
          onBlockClick={() => {
            const undressingSection = this.context.config.sections.find((s) => s.name === "undressing");
            const undressingBlock = undressingSection.blocks.find((s) => s.name === "undressing_common");

            this.handleBlockClick(undressingSection, undressingBlock);
          }}
        />
        {configSections.map((section, index) => (
          <SectionView
            key={section.name}
            section={section}
            position={index}
            blockRefHandler={this.handleBlockRef}
            onBlockClick={this.handleBlockClick}
          />
        ))}
      </IndexPageStyled>
    );
  }
}

IndexPage.contextType = AppContext;
